import clsx from "clsx";
import { caseArtFor } from "./caseArt";
import styles from "./CasePrint.module.scss";

/* UI-DESIGN: 2026-10-25 (Taco: each RSVP should feel like a new case file)
   the case's photo, printed and clipped to the paper. Cases with shipped art
   (caseArt.ts) or an API cover show it; any other case gets a stand-in print,
   marked in red pencil so nobody mistakes it for final art (LB-64 replaces
   it with our own). Never stock art. */
type CasePrintProps = { name?: string; imageUrl?: string | null; className?: string };

const CasePrint = ({ name, imageUrl, className }: CasePrintProps) => {
  const src = caseArtFor(name) ?? imageUrl ?? null;
  return (
    <figure className={clsx(styles.print, className)}>
      <span className={styles.clip} aria-hidden />
      {src ? (
        <img className={styles.photo} src={src} alt={name ? `${name} case photo` : "Case photo"} />
      ) : (
        <div className={styles.standIn} role="img" aria-label="Stand-in case photo; the real case art is still to come">
          <svg className={styles.glass} viewBox="0 0 48 48" aria-hidden>
            <circle cx="20" cy="20" r="12" fill="none" stroke="currentColor" strokeWidth="3" />
            <path d="M29 29 42 42" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
          </svg>
          <span className={styles.note} aria-hidden>stand-in photo</span>
        </div>
      )}
    </figure>
  );
};

export default CasePrint;
